import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    items: []
}

const slice = createSlice({
    name: 'notifiactions',
    initialState,
    reducers: {
        add(state, action) {
            const { type, title, message } = action.payload

            const key = `${type}_${title}_${message}`

            if (!state.items.find((item) => item.key === key)) {
                state.items.push({
                    key,
                    type,
                    title,
                    message
                })
            }
        },
        remove(state, action) {
            const { key } = action.payload
            state.items = [...state.items.filter((item) => item.key !== key)]
        }
    }
})

export const { reducer } = slice

export const addApiError = (apiResponse, title) => async (dispatch) => {
    const { statusCode, errorCode, errorMessage } = apiResponse || {}
    if (!errorCode || statusCode <= 400) return

    const payload = {
        type: 'error',
        title: `${title}`,
        message: ` ${errorMessage} `
    }
    dispatch(slice.actions.add(payload))
}

export const addApiSuccess =
    (apiResponse, title, message) => async (dispatch) => {
        const { statusCode, errorCode, errorMessage } = apiResponse || {}
        if (errorCode || statusCode > 200 || errorMessage) return

        const payload = { type: 'success', title, message }
        dispatch(slice.actions.add(payload))
    }

export const addApiInfo = (apiResponse, title, message) => async (dispatch) => {
    const { statusCode, errorCode, errorMessage } = apiResponse || {}
    if (errorCode || statusCode > 200 || errorMessage) return

    const payload = { type: 'info', title, message }
    dispatch(slice.actions.add(payload))
}

export const addShowInfo = (title, message) => async (dispatch) => {
    const payload = { type: 'info', title, message }
    dispatch(slice.actions.add(payload))
}

export const addShowSuccess = (title, message) => async (dispatch) => {
    const payload = { type: 'success', title, message }
    dispatch(slice.actions.add(payload))
}

export const removeEvent = (key) => async (dispatch) => {
    dispatch(slice.actions.remove({ key }))
}

export default {
    slice,
    addApiError,
    addApiSuccess,
    addApiInfo,
    addShowInfo,
    addShowSuccess,
    removeEvent
}
